import { render, staticRenderFns } from "./ledger.vue?vue&type=template&id=6935d96a&scoped=true"
import script from "./ledger.vue?vue&type=script&lang=js"
export * from "./ledger.vue?vue&type=script&lang=js"
import style0 from "./ledger.vue?vue&type=style&index=0&id=6935d96a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6935d96a",
  null
  
)

export default component.exports